export interface IUserIdCardItem {
    firstName: string;
    lastName: string;
    taxNumber: string;
    picture: string;
    archived: boolean;
    companyBusinessIdentityCode: string;
}

export class UserIdCardItem implements IUserIdCardItem {
    firstName: string;
    lastName: string;
    taxNumber: string;
    picture: string;
    archived: boolean;
    companyBusinessIdentityCode: string;

    constructor();
    constructor(obj: IUserIdCardItem);
    constructor(obj?: any) {
        this.firstName = obj && obj.firstName || "";
        this.lastName = obj && obj.lastName || "";
        this.taxNumber = obj && obj.taxNumber || "";
        this.picture = obj && obj.picture || "";
        this.archived = obj && obj.archived || false;
        this.companyBusinessIdentityCode = obj && obj.companyBusinessIdentityCode || "";
    }
}